import { useEffect, useState } from "react";
import api, { formatApiError } from "@/lib/api";
import { Plus, Edit, Trash2 } from "lucide-react";
import { toast } from "sonner";
import { Dialog, DialogContent, DialogHeader, DialogTitle, DialogTrigger } from "@/components/ui/dialog";

const inputCls = "w-full rounded-lg border border-slate-200 px-3 py-2 text-sm focus:outline-none focus:border-[#0077B6]";
const empty = { name: "", slug: "", description: "", image_url: "", order: 0 };

export default function AdminCategories() {
  const [list, setList] = useState([]);
  const [open, setOpen] = useState(false);
  const [form, setForm] = useState(empty);
  const [editId, setEditId] = useState(null);

  const load = () => api.get("/categories").then((r) => setList(r.data));
  useEffect(() => { load(); }, []);

  const submit = async (e) => {
    e.preventDefault();
    const payload = { ...form, order: Number(form.order) };
    try {
      if (editId) await api.put(`/admin/categories/${editId}`, payload);
      else await api.post("/admin/categories", payload);
      toast.success("Kaydedildi");
      setOpen(false); load();
    } catch (err) { toast.error(formatApiError(err)); }
  };

  const del = async (id) => {
    if (!window.confirm("Silmek istediğinize emin misiniz?")) return;
    await api.delete(`/admin/categories/${id}`); load();
  };

  return (
    <div>
      <div className="flex items-center justify-between mb-6">
        <h1 className="font-display text-3xl font-extrabold tracking-tight">Kategoriler</h1>
        <Dialog open={open} onOpenChange={setOpen}>
          <DialogTrigger asChild>
            <button onClick={() => { setForm(empty); setEditId(null); setOpen(true); }} className="btn-primary"><Plus size={16}/> Yeni</button>
          </DialogTrigger>
          <DialogContent>
            <DialogHeader><DialogTitle>{editId ? "Düzenle" : "Yeni Kategori"}</DialogTitle></DialogHeader>
            <form onSubmit={submit} className="space-y-3">
              <input required placeholder="Ad" className={inputCls} value={form.name} onChange={(e) => setForm({ ...form, name: e.target.value, slug: form.slug || e.target.value.toLowerCase().replace(/\s+/g, "-") })} />
              <input required placeholder="Slug" className={inputCls} value={form.slug} onChange={(e) => setForm({ ...form, slug: e.target.value })} />
              <textarea placeholder="Açıklama" className={inputCls} rows={3} value={form.description} onChange={(e) => setForm({ ...form, description: e.target.value })} />
              <input placeholder="Görsel URL" className={inputCls} value={form.image_url} onChange={(e) => setForm({ ...form, image_url: e.target.value })} />
              <input type="number" placeholder="Sıralama" className={inputCls} value={form.order} onChange={(e) => setForm({ ...form, order: e.target.value })} />
              <button className="btn-primary w-full">Kaydet</button>
            </form>
          </DialogContent>
        </Dialog>
      </div>

      <div className="grid md:grid-cols-3 gap-4">
        {list.map((c) => (
          <div key={c.id} className="bg-white rounded-2xl border border-slate-100 overflow-hidden">
            <img src={c.image_url} alt={c.name} className="w-full aspect-video object-cover" />
            <div className="p-4">
              <div className="font-display font-bold">{c.name}</div>
              <div className="text-xs text-slate-500 mb-3">/{c.slug}</div>
              <div className="flex gap-2">
                <button onClick={() => { setForm(c); setEditId(c.id); setOpen(true); }} className="text-[#0077B6] text-sm font-semibold flex items-center gap-1"><Edit size={13}/> Düzenle</button>
                <button onClick={() => del(c.id)} className="text-rose-600 text-sm font-semibold flex items-center gap-1 ml-auto"><Trash2 size={13}/> Sil</button>
              </div>
            </div>
          </div>
        ))}
      </div>
    </div>
  );
}
